export async function getUserCity() {
  if (typeof navigator === 'undefined' || !navigator.geolocation || typeof fetch !== 'function') {
    console.error('Location lookup unavailable: browser geolocation or fetch is not supported');
    return null;
  }

  let position;
  try {
    position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 300000
      });
    });
  } catch (error) {
    console.error('Geolocation failed:', error);
    return null;
  }

  const { latitude, longitude } = position.coords || {};
  if (
    !Number.isFinite(latitude) ||
    !Number.isFinite(longitude) ||
    latitude < -90 ||
    latitude > 90 ||
    longitude < -180 ||
    longitude > 180
  ) {
    console.error('Geolocation returned invalid coordinates:', { latitude, longitude });
    return null;
  }

  const apiUrl = process.env.REACT_APP_API_URL;
  if (!apiUrl) {
    console.error('Reverse geocoding failed: REACT_APP_API_URL is not configured');
    return null;
  }

  try {
    const apiBase = apiUrl.replace(/\/$/, '').replace(/\/api$/, '');
    const url = `${apiBase}/reverse-geocode?${new URLSearchParams({
      latitude: String(latitude),
      longitude: String(longitude)
    })}`;
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const city = data.city ||
      data.locality ||
      data.town ||
      data.village ||
      data.municipality ||
      data.county ||
      data.state ||
      data.address?.city ||
      data.address?.town ||
      data.address?.village ||
      data.address?.municipality ||
      data.address?.county ||
      data.address?.state ||
      data.result?.city ||
      data.result?.locality ||
      null;
    if (city) {
      return city;
    }
    console.error('Reverse geocoding returned no city:', data);
  } catch (error) {
    console.error('Reverse geocoding request failed:', error);
  }

  return null;
}

export function injectOrigin(prompt, city) {
  if (!prompt) return prompt;
  const trimmed = city && city.trim ? city.trim() : city;
  if (trimmed) {
    return prompt
      .replace(/Dublin/g, trimmed)
      .replace(/Dublín/g, trimmed)
      .replace(/都柏林/g, trimmed)
      .replace(/डबलिन/g, trimmed);
  }
  let p = prompt;
  p = p.replace(/\s*saindo de Dublin\s*/gi, ' ');
  p = p.replace(/\s*departing from Dublin\s*/gi, ' ');
  p = p.replace(/\s*saliendo de Dublín\s*/gi, ' ');
  p = p.replace(/\s*saliendo de Dublin\s*/gi, ' ');
  p = p.replace(/\s*au départ de Dublin\s*/gi, ' ');
  p = p.replace(/\s*au depart de Dublin\s*/gi, ' ');
  p = p.replace(/从都柏林出发[，,、\s]*/g, '');
  p = p.replace(/从Dublin出发[，,、\s]*/g, '');
  p = p.replace(/डबलिन से प्रस्थान करने वाले\s*/g, '');
  p = p.replace(/\s*Dublin\s*/g, ' ');
  p = p.replace(/\s*Dublín\s*/g, ' ');
  p = p.replace(/都柏林/g, '');
  p = p.replace(/डबलिन/g, '');
  p = p.replace(/\s{2,}/g, ' ');
  p = p.replace(/\s+([,，.。])/g, '$1');
  p = p.replace(/\s+em ritmo/gi, ' em ritmo');
  p = p.replace(/\s+at a /gi, ' at a ');
  return p.trim();
}
